import { useSearchParams } from "react-router-dom";
import { UsersPage as UsersPageView, type UsersListFilters } from "@/components/UsersPage";

export function UsersPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultFilters: UsersListFilters = {
    email: searchParams.get("email") ?? undefined,
  };

  function handleFiltersChange(filters: UsersListFilters) {
    const next = new URLSearchParams();
    if (filters.email) next.set("email", filters.email);
    setSearchParams(next, { replace: true });
  }

  return (
    <UsersPageView
      defaultFilters={defaultFilters}
      onFiltersChange={handleFiltersChange}
    />
  );
}
